class AmbassadorStore {
	constructor() {
		this.emails = [];
	}

	addEmail(email) {
		this.emails.push(email);
	}

	removeEmail(removeEmail) {
		this.emails = this.emails.filter(email => email !== removeEmail);
	}

	getEmails() {
		return this.emails;
	}
	clearEmails() {
		this.emails = [];
	}
}

export const ambassadorStore = new AmbassadorStore();
